import * as React from 'react';
import {Field, InjectedFormProps, reduxForm, reset} from 'redux-form';
import {Button, ButtonGroup} from 'reactstrap';
import renderSelectField from '../../../../theme/components/form/Select';
import Panel from '../../../../theme/components/Panel';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {error} from '../../../../utils/notification-actions';
import validate from './validate';
import renderDatePickerField from '../../../../theme/components/form/DatePicker';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import * as moment from 'moment';

interface IState {
    periodos: string[];
    filtros: any[];
    showPeriodo: boolean;
    showFecha: boolean;
}


class PrioritariosForm extends React.PureComponent<InjectedFormProps & ReduxProps, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props) {
        super(props);
        this.state = {
            periodos: [],
            showFecha: false,
            showPeriodo: false,
            filtros: [{value: 'periodo', label: 'Periodo'}, {value: 'fecha', label: 'Fecha'}]
        };
        this.fetchPeriodos();
    };


    private async fetchPeriodos() {
        try {
            const response = await this.apiClient.getCelularZonaPeriodos();
            this.setState({periodos: response});
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al obtener periodos'));
        }
    }


    private handleFiltroChange = (obj) => {
        if (obj && obj.value === 'periodo') {
            this.setState({showPeriodo: true, showFecha: false})
        } else if (obj && obj.value === 'fecha') {
            this.setState({showPeriodo: false, showFecha: true})
        } else {
            this.setState({showPeriodo: false, showFecha: false})
        }
    };

    private handleReset = () => {
        this.setState({showPeriodo: false, showFecha: false});
        this.props.dispatch(reset('celulares-pdvs-form'));
    };

    public render() {
        const {handleSubmit} = this.props;

        return (
            <Panel xs={12} md={12} divider={true} title='Filtros'>
                <form className='form' onSubmit={handleSubmit}>
                    <div className='form__form-group'>
                        <label className='form__form-group-label'>Filtro por </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='filtro'
                                component={renderSelectField}
                                onChange={this.handleFiltroChange}
                                placeholder='Seleccione'
                                type='text'
                                options={this.state.filtros}
                            />
                        </div>
                    </div>
                    {this.state.showPeriodo ? <div className='form__form-group'>
                        <label className='form__form-group-label'>Periodo </label>
                        <div className='form__form-group-field'>
                            <Field
                                name='periodo'
                                component={renderSelectField}
                                placeholder='Seleccione'
                                type='text'
                                options={this.state.periodos.map((per) => {
                                    return {value: per, label: per}
                                })}
                            />
                        </div>
                    </div> : null}
                    {this.state.showFecha ? <div className='form__form-group'>
                        <label className='form__form-group-label'>Fecha</label>
                        <div className='form__form-group-field'>
                            <Field
                                name='fecha'
                                component={renderDatePickerField}
                                filterDate={(date) => {
                                    return moment() > date;
                                }}
                                defaultDate={moment()}
                                placeholder='dd/mm/yyyy'
                            />
                            <div className='form__form-group-icon'>
                                <CalendarBlankIcon/>
                            </div>
                        </div>
                    </div> : null}
                    <ButtonGroup className='btn-group--justified'>
                        <Button color='success' type='submit'>GENERAR REPORTE</Button>
                    </ButtonGroup>
                    <ButtonGroup className='btn-group--justified'>
                        <Button outline={true} type='button' onClick={this.handleReset}>LIMPIAR</Button>
                    </ButtonGroup>
                </form>
            </Panel>
        )
    }
}

export default reduxForm({
    form: 'celulares-pdvs-form', // a unique identifier for this form
    validate
})(PrioritariosForm);



// WEBPACK FOOTER //
// ./src/components/pages/celulares/zonas/celulares-pdvs-form.tsx